// extracted by mini-css-extract-plugin
export default {"auth":"Auth_auth__phEJu","auth__form":"Auth_auth__form__FOANB","auth__title":"Auth_auth__title__JCkrk","auth__button":"Auth_auth__button__R0ioF"};